<template>
  <div class="bg-img">
    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="topheader" v-show="!pageLoading">
      <div class="topheader__logo">
        <a href="http://hrdesk.africa/">
          <img
            src="./../../../assets/images/hrdesk-logo-dark-beta.png"
            alt="logo"
          />
        </a>
      </div>
      <div class="topheader__contact"></div>
    </div>

    <div class="signup-container" v-show="!pageLoading">
      <div class="card">
        <h2 class="card-heading">Sign Up</h2>
        <p class="card-text">Sign up on HRDesk in few minutes</p>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              v-model="formData.firstName"
              placeholder="John"
            />
            <span class="signup-error" v-if="errors.firstName">{{
              errors.firstName
            }}</span>
          </div>
          <div class="form-group">
            <label for="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              v-model="formData.lastName"
              placeholder="Doe"
            />
            <span class="signup-error" v-if="errors.lastName">{{
              errors.lastName
            }}</span>
          </div>
          <div class="form-group">
            <label for="companyName">Company Name</label>
            <input
              type="text"
              id="companyName"
              v-model="formData.companyName"
              placeholder="trading-plc"
            />
            <span class="signup-error" v-if="errors.companyName">{{
              errors.companyName
            }}</span>
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              id="email"
              v-model="formData.email"
              placeholder="example@example.com"
            />
            <span class="signup-error" v-if="errors.email">{{
              errors.email
            }}</span>
          </div>
          <div class="form-group">
            <label for="phoneNumber">Phone Number</label>
            <input
              type="tel"
              id="phoneNumber"
              v-model="formData.phoneNumber"
              placeholder="08012345678"
            />
            <span class="signup-error" v-if="errors.phoneNumber">{{
              errors.phoneNumber
            }}</span>
          </div>
          <div class="form-group">
            <label for="referral">Referral (optional)</label>
            <input type="text" id="referral" v-model="formData.referral" />
          </div>
          <div class="form-group">
            <label for="password">Create Password</label>
            <div class="password">
              <input
                :type="viewPassword ? 'text' : 'password'"
                id="password"
                v-model="formData.password"
                placeholder="********"
              />
              <span class="span" v-if="viewPassword" @click="togglePassword"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                  />
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                  /></svg
              ></span>
              <span class="span" v-else @click="togglePassword"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye-slash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                  />
                  <path
                    d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                  />
                  <path
                    d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                  /></svg
              ></span>
            </div>

            <span class="signup-error" v-if="errors.password">{{
              errors.password
            }}</span>
          </div>
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="password">
              <input
                :type="viewConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                v-model="formData.confirmPassword"
                placeholder="*********"
              />
              <span
                class="span"
                v-if="viewConfirmPassword"
                @click="toggleConfirmPassword"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                  />
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                  /></svg
              ></span>
              <span class="span" v-else @click="toggleConfirmPassword"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye-slash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                  />
                  <path
                    d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                  />
                  <path
                    d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                  /></svg
              ></span>
            </div>
            <span class="signup-error" v-if="errors.confirmPassword">{{
              errors.confirmPassword
            }}</span>
          </div>
          <div v-if="fetchErrors" class="error-message">
            <div v-for="(errors, field) in fetchErrors" :key="field">
              <span class="signup-error" v-for="error in errors" :key="error">{{
                error
              }}</span>
            </div>
          </div>
          <div v-if="serverError" class="error-message">
            <span class="signup-error">{{ serverError }}</span>
          </div>

          <div>
            <div class="btn-container">
              <button role="button" type="submit">
                <span v-show="!loading">Submit</span>
                <div v-show="loading">
                  <WhiteLoader />
                </div>
              </button>
            </div>
            <div>
              Got an account?
              <routerLink to="/signin"
                ><span class="forgotPassword">Sign In</span></routerLink
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Signup",

  components: {
    WhiteLoader,
    PageLoader,
  },
  data() {
    return {
      formData: {
        firstName: "",
        lastName: "",
        companyName: "",
        email: "",
        phoneNumber: "",
        referral: "",
        password: "",
        confirmPassword: "",
      },
      errors: {},
      fetchErrors: null,
      serverError: null,
      pageLoading: false,
      loading: false,
      viewConfirmPassword: false,
      viewPassword: false,
    };
  },
  metaInfo: {
    title: 'Sign Up - Hrdesk',
    meta: [
      { name: 'description', content: 'Create an account at hrdesk to access exclusive features and benefits.' },
      { property: 'og:title', content: 'Sign Up - hrdesk' },
      { property: 'og:description', content: 'Create an account at hrdesk to access exclusive features and benefits.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/signup' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'hrdesk' },
      { name: 'twitter:description', content: 'Create an account at hrdesk to access exclusive features and benefits.' },
      { name: 'keywords', content: 'sign up, register, create account, join us' },
    ]
  },
  methods: {
    togglePassword() {
      this.viewPassword = !this.viewPassword;
    },
    toggleConfirmPassword() {
      this.viewConfirmPassword = !this.viewConfirmPassword;
    },
    handleChange(e) {
      const { name, value } = e.target;
      this.formData[name] = value;
    },

    handleSubmit() {
      this.errors = {};
      this.serverError = null;

      if (!this.formData.firstName.trim()) {
        this.errors.firstName = "First name required";
      }
      if (!this.formData.lastName.trim()) {
        this.errors.lastName = "Last name required";
      }
      if (!this.formData.email.trim()) {
        this.errors.email = "Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(this.formData.email)) {
        this.errors.email = "Invalid email address";
      }
      if (!this.formData.companyName.trim()) {
        this.errors.companyName = "Company Name is required";
      } else if (this.formData.companyName.length < 3) {
        this.errors.companyName =
          "Company Name must be at least 3 characters long";
      }
      if (!this.formData.phoneNumber.trim()) {
        this.errors.phoneNumber = "Phone Number is required";
      } else if (!/^\d{11}$/.test(this.formData.phoneNumber)) {
        this.errors.phoneNumber = "Invalid phone number";
      }
      if (!this.formData.password.trim()) {
        this.errors.password = "Password is required";
      } else if (!this.isStrongPassword(this.formData.password)) {
        this.errors.password =
          "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
      }
      if (this.formData.password !== this.formData.confirmPassword) {
        this.errors.confirmPassword = "Passwords do not match";
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      this.loading = true;
      this.$http
        .post(types.CREATE_USER, {
          firstname: this.formData.firstName,
          lastname: this.formData.lastName,
          trading_name: this.formData.companyName,
          email: this.formData.email,
          phone: this.formData.phoneNumber,
          referral_code: this.formData.referral,
          password: this.formData.password,
          password_confirmation: this.formData.confirmPassword,
        })
        .then((resp) => {
          this.login();
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.fetchErrors = err.response.data.message;
          } else {
            this.serverError = err.response.data.message;
          }

          this.loading = false;
        });
    },
    login() {
      this.$store
        .dispatch(types.AUTH_REQUEST, {
          email: this.formData.email,
          password: this.formData.password,
        })
        .then((resp) => {
          this.$router.push({
            path: "/verify-email",
            query: { email: this.formData.email },
          });
        });
    },
    isStrongPassword(password) {
      const strongPasswordRegex =
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{":;'?/>.<,])(?=.*[^\w\d\s]).{8,}$/;
      return strongPasswordRegex.test(password);
    },
  },
};
</script>

<style scoped>
@import "./../../../assets/vendor/css/external.css";
@import "./../../../assets/vendor/css/style.css";

.password {
  position: relative;

  span {
    position: absolute;
    width: 4rem;
    padding: 0.7rem;
    top: 0;
    right: 0;
    color: #274980;
  }
}

.checkit {
  display: flex;
  justify-content: flex-start;
}

.forgotPassword {
  font-weight: 800;
  color: #274980;
}

.bg-img {
  background-image: url("https://uniswitch-public-assets.s3.amazonaws.com/bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
}

.error-message {
  margin: 1rem;
}

.topheader {
  min-height: 50px;
  margin: auto;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  /* border-bottom: 1px solid #efeff1; */

  /* @media (max-width: 750px) {
    flex-direction: column;
  } */

  > .topheader__logo {
    max-width: 100px;
    margin-left: 2rem;

    > img {
      width: 100%;
    }
  }
}

.signup-error {
  /* margin-top: 2px; */
  text-align: center;
  color: red;
  font-size: 0.9rem;
  font-style: italic;

  > p {
    margin: 0;
    margin-bottom: 0;
    /* text-align: center; */

    &::first-letter {
      text-transform: capitalize;
    }
  }

  > div {
    padding-bottom: 5px;
    background: #162b4c;
  }
}

.card-heading {
  color: black;
  margin-bottom: 0.5rem;
}

.card-text {
  color: #1514138f;
  margin-bottom: 2rem;
}

.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  /* height: 100vh; */
}

.card {
  width: 90%;
  max-width: 700px;
  padding: 25px;
  border: 2px solid #93a4bf;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.form-group {
  flex-basis: 100%;
  margin-bottom: 0px;
  text-align: left;
  gap: 2rem;
}

label {
  display: block;
  margin-bottom: 7px;
  font-weight: semibold;
  color: #1514138f;
  margin-top: 8px;
}

input {
  width: 100%;
  padding: 10px;
  border: 2px solid #93a4bf;
  border-radius: 8px;
  margin-bottom: 1px;
}

.btn-container {
  width: full;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

button {
  width: 15vw;
  padding: 10px;
  background-color: #274980;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 10px;
}

button:hover {
  background-color: #162b4c;
}

.page-loader {
  margin-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

@media (max-width: 750px) {
  button {
    width: 75vw;
  }

  .card-heading {
    font-size: 2.5rem;
  }
}

@media screen and (min-width: 768px) {
  .form-group {
    flex-basis: calc(50% - 5px);
  }
}
</style>
